const isProd = process.env.REACT_APP_ENV === "prod";

export const API_BASE_URL = isProd
  ? "https://bnf-platform-gateway-105-cxxxw2c5.uc.gateway.dev/"
  : "http://localhost:3001/";